const escapeCSV = (value) => {
  if (!value) return '';
  const str = String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

const formatPhoneForExport = (contact) => {
  let phone = contact.mobilePhone || contact.fixedPhone || '';

  if (phone && !phone.startsWith('+')) {
    if (phone.startsWith('381')) {
      phone = '+' + phone;
    } else if (phone.startsWith('0')) {
      phone = '+381' + phone.substring(1);
    } else {
      const phoneDigits = phone.replace(/\D/g, '');
      if (phoneDigits.length >= 9 && phoneDigits.length <= 15) {
        if (phoneDigits.startsWith('381')) {
          phone = '+' + phoneDigits;
        } else {
          phone = '+381' + phoneDigits;
        }
      } else {
        phone = '+' + phoneDigits;
      }
    }
  }

  return phone ? `="${phone}"` : '';
};

const contactToCsvRow = (contact) => {
  let firstName = '';
  let lastName = '';

  if (contact.companyName) {
    const nameParts = contact.companyName.trim().split(/\s+/);
    if (nameParts.length > 1) {
      firstName = nameParts[0];
      lastName = nameParts.slice(1).join(' ');
    } else {
      lastName = contact.companyName;
    }
  }

  return [
    escapeCSV(firstName),
    escapeCSV(lastName),
    formatPhoneForExport(contact),
    escapeCSV(contact.email || ''),
    escapeCSV(contact.companyName || '')
  ].join(',');
};

export const buildBusinessContactsCsv = (contacts) => {
  const csvHeaders = ['First Name', 'Last Name', 'Phone', 'Email', 'Company'];
  const csvRows = contacts.map(contactToCsvRow);
  const csvContent = [csvHeaders.join(','), ...csvRows].join('\n');
  return '\uFEFF' + csvContent;
};
